
import { getFEWalletParams } from "../../../../platform.pay.config";
import translate from "./../../../lib/translate/TranslateJs";

export function insufficientToWithdrawModal(){
  const {modalTip} = getFEWalletParams();
  return modalTip.confirm({
      wrapClassName:"commonWhiteModal insufficentWithdrawalModal",
      onlyOKBtn:true,
      isNoHeadBg: true,
      type:"confirm",
      title: translate("溫馨提示(餘額不足modal)")(),
      children: translate("餘額不足(餘額不足modal)")(), //三端共用 不可使用html tag會導致APP crash
      okBtnTxt: translate("明白了(餘額不足modal)")(),
      okFunction: () => { },
  })
}
